<!-- src/components/yuyue/modals/AddUserModal.vue -->
<template>
    <div class="modal" :class="{ active: isVisible }">
        <div class="modal-content">
            <div class="modal-header">
                <h3 class="modal-title">{{title }}</h3>
                <button class="close-modal" @click="closeModal">&times;</button>
            </div>
            <form @submit.prevent="submitForm">
                <!-- User Type Selection -->
                <div class="form-group" v-if="handleType !=='modify'" >
                    <label>用户类型 *</label>
                    <select v-model="form.resvType"   required  @change="onUserTypeChange">
                        <option value="">请选择用户类型</option>
                        <option value="edu">教育</option>
                        <option value="sound">音疗</option>
                    </select>
                </div>
                <!-- Education User Fields -->
                <div v-if="form.resvType == 'edu'">
                    <div class="form-group">
                        <label>姓名 *</label>
                        <input type="text" v-model="form.name" required />
                    </div>
                    <div class="form-group">
                        <label>学校/机构 *</label>
                        <input type="text" v-model="form.organization" required />
                    </div>
                    <div class="form-group">
                        <label>职位 *</label>
                        <select v-model="form.position" required>
                            <option value="">请选择职位</option>
                            <option value="teacher">教师</option>
                            <option value="psychologist">心理老师</option>
                            <option value="administrator">学校管理者</option>
                            <option value="parent">家长</option>
                            <option value="other">其他</option>
                        </select>
                    </div>
                    <div class="form-row">
                        <div class="form-group">
                            <label>联系电话 或 电子邮箱 *</label>
                            <input type="tel"
                                   v-model="form.phone"
                                   :required="!form.email"
                                   placeholder="联系电话" />
                        </div>
                        <div class="form-group">
                            <label>&nbsp;</label>
                            <input type="email"
                                   v-model="form.email"
                                   :required="!form.phone"
                                   placeholder="电子邮箱" />
                        </div>
                    </div>
                    <small style="color: #666; display: block; margin-top: -15px; margin-bottom: 15px;">请输入联系电话或电子邮箱至少一项</small>
                    <div class="form-group">
                        <label>您感兴趣的模块 *</label>
                        <div class="interest-grid">
                            <div class="interest-option"
                                 :class="{ selected: form.interestedModules.includes('teacher') }"
                                 @click="toggleModule('teacher')">
                                <i class="fas fa-chalkboard-teacher"></i>
                                <span>教师功能</span>
                            </div>
                            <div class="interest-option"
                                 :class="{ selected: form.interestedModules.includes('student') }"
                                 @click="toggleModule('student')">
                                <i class="fas fa-user-graduate"></i>
                                <span>学生功能</span>
                            </div>
                            <div class="interest-option"
                                 :class="{ selected: form.interestedModules.includes('parent') }"
                                 @click="toggleModule('parent')">
                                <i class="fas fa-user-friends"></i>
                                <span>家长功能</span>
                            </div>
                            <div class="interest-option"
                                 :class="{ selected: form.interestedModules.includes('all') }"
                                 @click="toggleModule('all')">
                                <i class="fas fa-th-large"></i>
                                <span>全部功能</span>
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label>其他需求说明</label>
                        <textarea v-model="form.other" placeholder="请描述您的具体需求..."></textarea>
                    </div>
                    <div class="form-group">
                        <label>备注</label>
                        <textarea v-model="form.handle_tip"></textarea>
                    </div>
                </div>
                <!-- Sound Therapy User Fields -->
                <div v-else-if="form.resvType === 'sound'">
                    <div class="form-row">
                        <div class="form-group">
                            <label for="name">姓名 *</label>
                            <input type="text" id="name" v-model="form.name" placeholder="请输入您的姓名" required>
                        </div>
                        <div class="form-group">
                            <label for="organization">公司/机构</label>
                            <input type="text" id="company" v-model="form.organization" placeholder="请输入公司或机构名称">
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group">
                            <label for="email">邮箱 *</label>
                            <input type="email" id="email" v-model="form.email" placeholder="请输入您的邮箱" :required="!form.phone">
                        </div>
                        <div class="form-group">
                            <label for="phone">电话 *</label>
                            <input type="tel" id="phone" v-model="form.phone" placeholder="请输入您的联系电话" :required="!form.email">
                        </div>
                    </div>
                    <div class="form-group">
                        <label>感兴趣的应用场景</label>
                        <div class="interest-grid">

                            <div class="interest-option"
                                 :class="{ selected: form.interestedModules.includes('company') }"
                                 @click="toggleModule('company')">
                                <i class="fas fa-briefcase-medical"></i>
                                <span>企业健康管理</span>
                            </div>
                            <div class="interest-option"
                                 :class="{ selected: form.interestedModules.includes('medical') }"
                                 @click="toggleModule('medical')">
                                <i class="fas fa-hospital-user"></i>
                                <span>医疗辅助治疗</span>
                            </div>
                            <div class="interest-option"
                                 :class="{ selected: form.interestedModules.includes('hotel') }"
                                 @click="toggleModule('hotel')">
                                <i class="fas fa-hotel"></i>
                                <span>高端酒店服务</span>
                            </div>
                            <div class="interest-option"
                                 :class="{ selected: form.interestedModules.includes('personal') }"
                                 @click="toggleModule('personal')">
                                <i class="fas fa-home"></i>
                                <span>个人家庭使用</span>
                            </div>
                            <div class="interest-option"
                                 :class="{ selected: form.interestedModules.includes('other') }"
                                 @click="toggleModule('other')">
                                <i class="fas fa-ellipsis-h"></i>
                                <span>其他场景</span>
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="description">需求描述</label>
                        <textarea id="description" v-model="form.other" placeholder="请描述您的具体需求..."></textarea>
                    </div>
                </div>
                <!-- Submit Button -->
                <div class="form-actions" >
                    <button type="button" class="btn btn-secondary" @click="closeModal">取消</button>
                    <button type="submit" class="btn btn-primary">{{handleType ==='modify'? "更新":"添加用户"}}</button>
                </div>
            </form>
        </div>
    </div>
</template>
<script>
    import { EventBus } from '@/eventBus.js';
    import axios from 'axios';
    export default {
        name: 'AddUserModal',
        data() {
            return {
                preObj: null,
                title:"添加用户",
                isVisible: false,
                handleType: null,
                form: {
                    resvType: '',
                    name: '',
                    organization: '',
                    position: '',
                    phone: '',
                    email: '',
                    other: '',
                    handle_tip: '',
                    interestedModules:[],
                }
            }
        },
        methods: {
            async updateItem(checkRes) {
                const isInExpired = await this.$store.dispatch('isInExpired');
                if (!isInExpired) {
                    this.$message({
                        message: "登录已过期，请重新登录",
                        type: "error",
                    });
                    return;
                }
                const token = localStorage.getItem('token');
                const payload = {};
                for (const key in checkRes) {
                    if (key == "interestedModules") {
                        payload["interest"] = this.form.interestedModules.join();
                    } else {
                        payload[key] = checkRes[key];
                    }
                }
                payload['id'] = this.form.id;
                try {
                    const response = await axios.post('/api/reservation/update', payload, {
                        headers: {
                            'Authorization': `Bearer ${token}`
                        }
                    });

                    if (response.status !== 200) {
                        this.$message({
                            message: "网络异常，请稍后尝试",
                            type: "error",
                        });
                        console.error(response.status);
                        return;
                    }
                    if (response.data.code !== "00") {
                        this.$message({
                            message: response.data.message,
                            type: "error",
                        });
                        return;
                    }
                    this.$message({
                        message: "操作成功",
                        type: "success",
                    });
                    EventBus.$emit('freshUserList');
                    this.closeModal();
                } catch (error) {
                    console.error(' failed:', error);
                    this.$message({
                        message: "网络异常，请稍后尝试",
                        type: "error",
                    });
                }
            },
            checkChanges() {
                const changedFields = {};
                for (const key in this.preObj) {
                    if (Object.prototype.hasOwnProperty.call(this.preObj, key) &&
                        Object.prototype.hasOwnProperty.call(this.form, key) &&
                        this.preObj[key] !== this.form[key]) {
                        if (key == "interestedModules") {
                            // 比较两个数组是否相等（内容相同但顺序可能不同）
                            const preModules = this.preObj[key].slice().sort();
                            const currentModules = this.form[key].slice().sort();

                            if (preModules.length !== currentModules.length) {
                                changedFields[key] = this.form[key];
                            } else {
                                for (let i = 0; i < preModules.length; i++) {
                                    if (preModules[i] !== currentModules[i]) {
                                        changedFields[key] = this.form[key];
                                        break;
                                    }
                                }
                            }
                        } else {
                            changedFields[key] = this.form[key];
                        }
                    }
                }

                // 检查form中是否有新增的属性
                for (const key in this.form) {
                    if (Object.prototype.hasOwnProperty.call(this.form, key) &&
                        !Object.prototype.hasOwnProperty.call(this.preObj, key)) {
                        changedFields[key] = this.form[key];
                    }
                }

                return {
                    hasChanged: Object.keys(changedFields).length > 0,
                    changedFields: changedFields
                };
            },
            async addItem() {
                const isInExpired = await this.$store.dispatch('isInExpired');
                if (!isInExpired) {
                    this.$message({
                        message: "登录已过期，请重新登录",
                        type: "error",
                    });
                    return;
                }
    
                const token = localStorage.getItem('token');
                try {
                    const payload = {
                        id: -1,
                        name: this.form.name,
                        organization: this.form.organization,
                        position: this.form.position,
                        phone: this.form.phone,
                        email: this.form.email,
                        interest: this.form.interestedModules.join(),
                        other: this.form.other,
                        handle_time: this.form.handle_time,
                        handle_tip: this.form.handle_tip,
                        state: this.form.state,
                        resvType: this.form.resvType,
                    };
                    const response = await axios.post('/api/reservation/append', payload, {
                        headers: {
                            'Authorization': `Bearer ${token}`
                        }
                    });

                    if (response.status !== 200) {
                        this.$message({
                            message: "网络异常，请稍后尝试",
                            type: "error",
                        });
                        console.error(response.status);
                        return;
                    }
                    if (response.data.code !== "00") {
                        this.$message({
                            message: "网络异常，请稍后尝试",
                            type: "error",
                        });
                        return;
                    }
                    this.$message({
                        message: "添加成功",
                        type: "success",
                    });
                    if (this.handleType === "edu") {
                        EventBus.$emit('freshEduList');
                    } else if (this.handleType === "sound") {
                        EventBus.$emit('freshSoundList');
                    } else {
                        EventBus.$emit('freshUserList');
                    }
                    this.closeModal();
                } catch (error) {
                    console.error(' failed:', error);
                    this.$message({
                        message: "网络异常，请稍后尝试",
                        type: "error",
                    });
                }
            },
            show(type, userData) {
                this.resetForm();
                this.handleType = type;
                if (userData) {
                    try {
                        this.form = JSON.parse(userData);
                    } catch {
                        console.log("1");
                    }
                }
                
                if (type == "sound") {
                    this.title = "音疗产品预约"
                    
                } else if (type == "edu") {
                    this.from.type = type;
                    this.title = "教育产品预约";
                } else if (type == "modify") {
                    if (userData && this.form.resvType) {
                        if (this.form.resvType == "sound") {
                            this.title = "音疗产品预约"
                        } else {
                            this.title = "教育产品预约";
                        }
                        this.preObj = { ... this.form };
                        if (this.form.interest) {
                            this.preObj.interestedModules = this.preObj.interest.split(",");
                        }
                    } else {
                        this.title = "产品预约";
                    }                    
                } else {
                    this.title = "产品预约";
                }
                
                if (this.form.interest) {
                    this.form.interestedModules = this.form.interest.split(",");
                }
                this.isVisible = true;

            },
            closeModal() {
                this.isVisible = false;
                this.resetForm();
            },
            resetForm() {
                this.form = {
                    resvType: '',
                    name: '',
                    organization: '',
                    position: '',
                    phone: '',
                    email: '',
                    other: '',
                    handle_tip: '',
                    interest: '',
                    interestedModules:[],
                };
            },
            onUserTypeChange() {
                if (this.form.resvType == "sound") {
                    this.title = "音疗产品预约"
                } else if (this.form.resvType == "edu") {
                    this.title = "教育产品预约";
                } else {
                    this.title = "产品预约";
                }
            },
            toggleModule(module) {
                const index = this.form.interestedModules.indexOf(module);
                if (index > -1) {
                    this.form.interestedModules = this.form.interestedModules.filter(item => item !== module);
                } else {
                    this.form.interestedModules = [...this.form.interestedModules, module];
                }

                this.$forceUpdate();
                console.log(this.form.interestedModules);
            },
            submitForm() {
                // Validate required fields based on user type
                if (this.form.resvType === 'edu') {
                    if (!this.form.name || !this.form.organization || !this.form.position) {
                        alert('请填写所有必填字段');
                        return;
                    }
                    if (!this.form.phone && !this.form.email) {
                        alert('请至少填写联系电话或电子邮箱');
                        return;
                    }
                    if (this.form.interestedModules.length === 0) {
                        alert('请选择您感兴趣的模块');
                        return;
                    }
                } else if (this.form.resvType === 'sound') {
                    if (!this.form.name) {
                        alert('请填写姓名');
                        return;
                    }
                    if (!this.form.phone && !this.form.email) {
                        alert('请至少填写联系电话或电子邮箱');
                        return;
                    }
                }
                if (this.handleType !== "modify") {
                    this.addItem();
                } else {
                    const checkRes = this.checkChanges();
                    if (checkRes.hasChanged) {
                        this.updateItem(checkRes.changedFields);
                    } else {
                        this.$message({
                            message: "无改动，关闭中",
                            type: "success",
                        });
                        this.closeModal();
                    }
                }
            }
        }
    }

</script>
<style scoped>
    /* Form row for two-column layout */
    .form-row {
        display: flex;
        gap: 15px;
        margin-bottom: 15px;
    }
        .form-row .form-group {
            flex: 1;
            margin-bottom: 0;
        }
    .form-group {
        text-align:left;
        margin-bottom: 20px;
    }
        .form-group label {
            display: block;
            margin-bottom: 8px;
            font-weight: 500;
            color: #444;
        }
        .form-group input,
        .form-group select,
        .form-group textarea {
            width: 100%;
            padding: 10px 15px;
            border: 1px solid #e0e6ef;
            border-radius: 6px;
            font-size: 0.95rem;
            transition: all 0.3s;
            font-family: 'Noto Sans SC', sans-serif;
        }
            .form-group input:focus,
            .form-group select:focus,
            .form-group textarea:focus {
                border-color: #1a73e8;
                outline: none;
                box-shadow: 0 0 0 2px rgba(26, 115, 232, 0.2);
            }
        .form-group textarea {
            min-height: 100px;
        }
    /* Interest grid for module selection */
    .interest-grid {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
        gap: 15px;
        margin-top: 10px;
    }
    .interest-option {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 15px 10px;
        border: 2px solid #e0e6ef;
        border-radius: 8px;
        cursor: pointer;
        transition: all 0.3s;
        text-align: center;
        background: #f9fbfe;
    }
        .interest-option:hover {
            border-color: #1a73e8;
            background: #e3f2fd;
        }
        .interest-option.selected {
            border-color: #1a73e8;
            background: #e3f2fd;
            box-shadow: 0 4px 8px rgba(26, 115, 232, 0.15);
        }
        .interest-option i {
            font-size: 1.5rem;
            margin-bottom: 8px;
            color: #1a73e8;
        }
        .interest-option span {
            font-size: 0.9rem;
            font-weight: 500;
        }
    /* Responsive design */
    @media (max-width: 768px) {
        .form-row {
            flex-direction: column;
            gap: 0;
        }
        .interest-grid {
            grid-template-columns: repeat(2, 1fr);
        }
    }
    @media (max-width: 480px) {
        .interest-grid {
            grid-template-columns: 1fr;
        }
    }
</style>
